import {createRouter, createWebHistory} from 'vue-router'

const Layout = () => import('../views/layout/index.vue')
const routes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '山东兆通业绩统计系统',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/index/index')
            },
        ]
    },
    {
        path: '/data',
        component: Layout,
        children: [
            {
                path: 'statistics',
                meta: {
                    title: '业绩统计',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/data/statistics')
            },{
                path: 'target',
                meta: {
                    title: '目标达成',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/data/target')
            },
        ]
    },{
        path: '/record',
        component: Layout,
        children: [
            {
                path: 'record',
                meta: {
                    title: '业绩记录',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/record/record')
            },
        ]
    },
    {
        path: '/login',
        meta: {
            title: '登录'
        },
        component: () => import(/* webpackChunkName:'second' */ '../views/index/login')
    },
    /* 本段代码放在最后，未设置路由的地址跳转404 */
    {
        path: '/:catchAll(.*)',
        redirect: '/404'
    },
    {
        path: '/404',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '页面不存在'
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/404')
            },
        ]
    },
    /** 本段代码放在最后，未设置路由的地址跳转404 */
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
